"use strict";
/* globals module */
/**
 * @module applicationSettingsClient
 * @description  Application Settings Client provides an easy way to consume  Application Settings REST API end-points. In order to obtain needed routes `applicationSettingsClient` uses `applicationSettingsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../httpApi");
var _1 = require("./");
var ApplicationSettingsClient = /** @class */ (function () {
    function ApplicationSettingsClient(applicationSettingsRoute, apiClient) {
        this.applicationSettingsRoute = applicationSettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ApplicationSettingsClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `applicationSettingsRoute`.
         * @method
         * @example ApplicationSettingsClient.routeDefinition.get(options)
         **/
        get: function () {
            return this.applicationSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of application resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @example applicationClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ApplicationSettingsClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified application resource.
     * @method
     * @param id A application identifier.
     * @param options Query resources options.
     * @returns A promise that is resolved once the get action has been performed.
     * @example applicationClient.get({
                    id : '<id>',
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ApplicationSettingsClient.prototype.get = function (id) {
        return this.apiClient.get(this.routeDefinition.get(id));
    };
    /**
     * Returns a promise that is resolved once the create application action has been performed; this action creates a new application.
     * @method
     * @param data An application object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create application action has been performed.
     * @example applicationClient.create({
                    email : '<email>',
                    password : '<password>',
                    name : '<name>',
                    identifier : '<identifier>',
                    additionalProperty: '<additional-property>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ApplicationSettingsClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update application action has been performed; this action updates a application.
     * @param data A application object used to update specified application resource.
     * @returns A promise that is resolved once the update application action has been performed.
     * @method
     * @example  applicationClient.update(application)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ApplicationSettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove application action has been performed. This action will remove a application from the system if successfully completed.
     * @method
     * @param data  A application object used to delete specified application resource.
     * @returns A promise that is resolved once the remove application action has been performed.
     * @example applicationClient.remove(application)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ApplicationSettingsClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the update application activate action has been performed; this action activates a application.
     * @param data A application object used to activate specified application resource.
     * @returns A promise that is resolved once the activate application action has been performed.
     * @method
     * @example  applicationClient.activate(id)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ApplicationSettingsClient.prototype.activate = function (id) {
        return this.apiClient.put(this.routeDefinition.activate(id), {});
    };
    /**
     * Returns a promise that is resolved once the deactivate application action has been performed; this action deactivate a application.
     * @param data A application object used to deactivate specified application resource.
     * @returns A promise that is resolved once the deactivate application action has been performed.
     * @method
     * @example  applicationClient.deactivate(id)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ApplicationSettingsClient.prototype.deactivate = function (id) {
        return this.apiClient.put(this.routeDefinition.deactivate(id), {});
    };
    var _a, _b;
    ApplicationSettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ApplicationSettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ApplicationSettingsRoute !== "undefined" && _1.ApplicationSettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ApplicationSettingsClient);
    return ApplicationSettingsClient;
}());
exports.ApplicationSettingsClient = ApplicationSettingsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
